import React, { useContext } from "react";
import { NewtworkContext } from "../../../Layouts/Mint";
import { useWizard } from "react-use-wizard";
import { Wizard } from "react-use-wizard";

import Mint from "./Mint";
import { StepWrapper } from "../Components";
import Invitations from "./Invitations";
import Thankyou from "./Thankyou";
import Success from "./Success";

const Play: React.FC = () => {
  const network = useContext(NewtworkContext);
  const { handleStep } = useWizard();

  handleStep(() => {
    network?.setActiveStep(3);
  });
  return (
    <section className="flex items-center justify-center py-4 tab:py-12">
      <Wizard wrapper={<StepWrapper />}>
        <Mint />
        <Success />
        <Invitations />
        <Thankyou />
      </Wizard>
    </section>
  );
};

export default Play;
